import {
  ACTION_DELETE_SITE__REQUEST,
  ACTION_DELETE_SITE__SUCCESS,
  ACTION_DELETE_SITE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE__REQUEST:
    case ACTION_DELETE_SITE__SUCCESS:
      return null;

    case ACTION_DELETE_SITE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
